<template>
    <div class="panel">
        <div class="title-banner">
            <span class="title">产品详情</span>
        </div>
        <div v-html="info.introduction"></div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    export default {
        name: "ProductPartThree",
        props:{
            product_id:{
                type:String,
                default:'',
                required:false,
            }
        },
        data(){
            return {
                info:{},
            }
        },
        methods:{
            ...mapActions([
                'GetProductPublishedIntroduction',
            ]),
            loadData(){
                let product_id=this.product_id;
                this.GetProductPublishedIntroduction({product_id}).then(res=>{
                    this.info = res;
                })
            }
        },
        mounted() {
            this.loadData();
        }
    }
</script>

<style lang="scss" scoped>
    .panel{
        background-color: #FFFFFF;
        margin-top: 5px;
    }

    .title-banner{
        padding: 5px;
        text-align: left;
        .title{
            font-size: 14px;
            color: #333333;
            font-weight: bold;
        }
        .help-icon{
            font-size: 18px;
            color: #666666;
            float: right;
        }
    }
</style>